import React, { useContext } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { CartContext } from "./layout"
import CartItem from "./cartItem"
import { resolveCartItems } from "../utils/cartHelper"

const Cart = ({ _showCart, updateCart }) => {
    const { cart, showCart } = useContext(CartContext)
    const data = useStaticQuery(graphql`
    query Products {
        allProduct{
            nodes{
                name
                category
                price
                offer
                types{
                    size
                    material
                    p
                    s
                }
                priceList{
                    size
                    varients{
                        t
                        p
                    }
                }
                meta {
                    id
                }
            }
        }
    }`)
    const products = data?.allProduct?.nodes || []
    const { items: cartItems, total } = resolveCartItems(cart, products)
    const hideCart = (event) => {
        event.preventDefault();
        if (event.target.classList.contains('cart-backdrop')) {
            showCart()
        }
    }
    return (
        <div className={'cart-backdrop' + (_showCart ? "" : " d-none")} onClick={(e) => hideCart(e)} onKeyDown={(e) => hideCart(e)} role="presentation">
            <div className="cart-wrapper">
                <div className="row d-flex">
                    <div className="col text-center d-flex justify-content-center">
                        <h4>Your Cart</h4>
                        <i className="close-cart bi bi-x-square h4 text-dark" onClick={() => showCart()} onKeyDown={(e) => showCart(e)} role="presentation"></i>
                    </div>
                    <hr />
                    <div className={(cartItems.length ? '' : 'd-none ') + 'cart-items'}>
                        {
                            cartItems.map((item, i) => (
                                <CartItem item={item} index={i} key={i} updateCart={updateCart}></CartItem>
                            ))
                        }
                    </div>
                    <div className={(cartItems.length ? 'd-none ' : '') + 'text-center mt-5'}>
                        <h5>Your cart is empty!</h5>
                        <Link to="/" onClick={() => showCart()}>Choose a suitable mattress for you</Link>
                    </div>
                    <div className={(cartItems.length ? '' : 'd-none ') + 'cart-info p-3 text-light text-center'}>
                        <p>You can add your GST details in the 'Address' section on the next page</p>
                        {/* <select className="form-control">
                            <option>Select Offer</option>
                            <option>Winter - Up To 40% Off</option>
                        </select>
                        <input type="text" className="form-control mt-2" placeholder="Have a Discount Code?" disabled></input> */}
                        <Link to="/checkout" onClick={() => showCart()}>
                            <button className="btn btn-lg btn-warning mt-5 d-flex justify-content-between" style={{ width: '100%' }}>BUY NOW - <strong>₹{total.toFixed(2)}</strong><i className="bi bi-chevron-double-right text-info" style={{ marginLeft: '10px', borderRadius: '50%', backgroundColor: '#fff', width: '32px', height: '32px', marginRight: '-5px' }}></i></button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Cart